import { Construction, type LucideIcon } from "lucide-react";
import { NavLink } from "react-router-dom";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/sidebar";

export function NavMain({
  items,
}: {
  items: {
    title: string;
    url: string;
    disabled?: boolean;
    underDevelopment?: boolean;
    icon?: LucideIcon;
  }[];
}) {
  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item, i) => (
          <SidebarMenuItem key={i}>
            <NavLink end to={item.url}>
              {({ isActive }) => (
                <SidebarMenuButton
                  disabled={item.disabled}
                  isActive={isActive}
                  tooltip={
                    item.underDevelopment
                      ? `${item.title} – Under utvikling`
                      : item.title
                  }
                >
                  {item.icon && (
                    <span className="relative inline-flex size-4 shrink-0">
                      <item.icon className="size-4" aria-hidden="true" />
                      {item.underDevelopment && (
                        <span
                          aria-hidden="true"
                          className="absolute -right-1 -top-1 hidden size-1.5 rounded-full bg-amber-500 group-data-[collapsible=icon]:block"
                        />
                      )}
                    </span>
                  )}
                  <span>{item.title}</span>
                  {item.underDevelopment && (
                    <span
                      title="Under utvikling"
                      className="ml-auto inline-flex shrink-0 text-amber-600 group-data-[collapsible=icon]:hidden dark:text-amber-400"
                    >
                      <Construction className="size-3.5" aria-hidden="true" />
                    </span>
                  )}
                  {item.underDevelopment && (
                    <span className="sr-only">Under utvikling</span>
                  )}
                </SidebarMenuButton>
              )}
            </NavLink>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
